import { WithCSS } from "@pathwright/ui/src/components/utils/styles"
import Animated from "animated/lib/targets/react-dom"
import { Component } from "react"
import { css } from "styled-components"
import PathStep from "./PathStep"

class PathStepsAnimator extends Component {
  state = {
    container: new Animated.Value(0),
    steps: this.props.steps.map(() => new Animated.Value(0))
  }

  componentDidMount() {
    if (this.props.expand) {
      this.expandAnimation(this.props.expand).start()
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.expand !== this.props.expand) {
      this.expandAnimation(nextProps.expand).start()
    }
  }

  expandAnimation = (expand) => {
    return Animated.parallel([
      Animated.spring(this.state.container, {
        toValue: expand ? 1 : 0,
        tension: 10
      }),
      Animated.stagger(
        50,
        this.state.steps.map((step, index, steps) => {
          // need to stagger starting with last index when collapsing
          const reverseIndex = steps.length - 1 - index
          return Animated.spring(steps[expand ? index : reverseIndex], {
            toValue: expand ? 1 : 0,
            tension: 10
          })
        })
      )
    ])
  }

  render() {
    const { container, steps } = this.state
    const { onEnterStep } = this.props
    return (
      <WithCSS
        as={Animated.div}
        css={css`
          overflow: hidden;
          transform: translateZ(0);
          background-color: whitesmoke;
        `}
        style={{
          height: container.interpolate({
            inputRange: [0, 1],
            outputRange: [0, steps.length * 40]
          })
        }}
      >
        {this.props.steps.map((step, index) => (
          <WithCSS
            key={index}
            as={Animated.div}
            css={css`
              background-color: whitesmoke;
              transform-origin: top center;
            `}
            style={{
              opacity: steps[index].interpolate({
                inputRange: [0, 1],
                outputRange: [0, 1]
              }),
              transform: [
                {
                  scale: steps[index].interpolate({
                    inputRange: [0, 1],
                    outputRange: [0.7, 1]
                  })
                }
              ]
            }}
          >
            <PathStep step={step} onEnterStep={onEnterStep} />
          </WithCSS>
        ))}
      </WithCSS>
    )
  }
}

PathStepsAnimator.displayName = "PathStepsAnimator"

export default PathStepsAnimator
